import { memo, useCallback } from 'react';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { dialog, dom } from 'app/utils';
import { Breadcrumb } from 'app/components';
import { Button } from 'app/components/common'
import { confirmations } from 'app/services';
import { IConfirmation } from 'app/models';

import { ProfileView, MediaView } from './views';
import Rejection from './rejection';

export default memo(() => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const model = useLoaderData() as IConfirmation;

  const onApprove = useCallback(() => dialog.confirm({
    message: t('confirmations.approve.question', { ...model }),
    accept: { label: t('app.approve'), className: 'ml-2 p-button-danger' },
    reject: { label: t('app.cancel') },
  }).then((accepted) => {
    if (accepted) confirmations.approve(model).then(({ success }) => {
      if (!success) return;

      dialog.toast({ severity: 'success', message: t('confirmations.approve.success') });
      navigate('..');
    });
  }), [t, navigate, model]);
  const onReject = useCallback(() => dialog.show({ key: 'confirmation.reject', closable: false,
    header: t('confirmations.title'),
    template: (<Rejection data={{ ...model }} onDone={(data) => {
      dialog.hide('confirmation.reject');
      if (data) navigate('..');
    }} />),
  }), [t, navigate, model]);

  const form: any = {
    className: dom.className('p-4', 'flex-auto', 'overflow-auto'),
  };

  return (
    <div className="h-full flex flex-column align-items-stretch">
      <div className="flex-none flex surface-200">
        <Breadcrumb className="flex-auto border-none border-noround bg-transparent" />
        <div className="flex flex-none m-2">
          <Button text severity="warning" href=".." icon="pi-times" label={t('app.cancel')} className="mr-2 px-3 py-1" />
          { model.status === 1 && <>
            <Button severity="danger" icon="mdi-close" label={t('app.reject')} className="mr-2 px-3 py-1" onClick={onReject} />
            <Button severity="success" icon="mdi-check" label={t('app.approve')} className="px-3 py-1" onClick={onApprove} />
          </> }
        </div>
      </div>
      <div { ...form }>
        { [1, 7, 8].includes(model.type) && <ProfileView profileId={model.objectId} payload={model.data} /> }
        { [6].includes(model.type) && <MediaView mediaId={model.objectId} /> }
      </div>
    </div>
  );
});
